Directives.NavSmallScreensDirective = function NavSmallScreensDirective() {

    // @ngInject
    function NavSmallScreensControllerFunc($scope, $rootScope, $injector, $state, branch, AppStates, ModalService, UsersManager, CompaniesManager, NavigationService,
                                           Enums, ReferralService, DeviceService, OnboardingService, UserService, PretrialersService, SetupGuideService, ClientPortalService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NavSmallScreensDirectiveController';
        var self = this;

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.AppStates = AppStates;
        this.NavigationService = NavigationService;
        this.OnboardingService = OnboardingService;
        this.DeviceService = DeviceService;
        this.Enums = Enums;
        this.ModalService = ModalService;
        this.UserService = UserService;
        this.PretrialersService = PretrialersService;
        this.SetupGuideService = SetupGuideService;
        this.ClientPortalService = ClientPortalService;
        this.user = UsersManager.getCurrUser();
        this.company = CompaniesManager.getCurrCompany();

        this.showClientAccessibility = this.UserService.shouldShowClientAccessibilityTopNav(this.user);

        //init
        this.clientPortalConfiguration = this.ClientPortalService.getConfiguration()
        this.showMobileMenu = this.PretrialersService.shouldShowCleanAtwsUI() ? this.PretrialersService.mobileNavigation : false;
        this.showSearchMobile = false;
        this.showActivityNotificationsMobile = false;
        this.showToolsMobile = false;
        this.ReferralService= ReferralService;
        this.isUserSubscribed = this.OnboardingService.isUserSubscribed();
        this.shouldBeAbleToUpgrade = this.user.shouldBeAbleToUpgrade();

        this.isNavCommunity = NavigationService.isNavCurrentCommunity();
        this.isNavPeople = NavigationService.isNavCurrentPeople();
        this.isNavContacts = NavigationService.isNavCurrentContacts();

        this.isUserClient = this.user.isClient();

        this.interactiveOrStreamlinedSetupGuide = this.user.getExistingAbTestVariation(this.Enums.ABTests.interactiveOnboarding);
        this.onboardingCardPersistence = this.SetupGuideService.getPersistenceHomeOnboardingCard();
        this.hasClickedCompleteMwebWizard = this.onboardingCardPersistence.hasClickedCompleteMwebWizard;

        // vendor notifications
        if (!this.isUserClient) {
            var activityNotifications = this.user.activity_notifications || [];
            this.totalUnseenNotifications = 0;
            activityNotifications.forEach(function (notification) {
                if (notification.seen === false) {
                    self.totalUnseenNotifications++;
                }
            });
        }

        this.showSearch = this.user.companyHasSubscription();

        // referral
        ////////////////////////////////////////////////////////
        // TODO : Remove from here
        // Need to use existing 'hb-refer-friend' directive,
        // but we need to rafactor it so it will fit here as
        // well. For now, extracted the logic from there
        ////////////////////////////////////////////////////////
        this.showReferrAFriend = false;
        if (this.user.companyHasSubscription()) {
            this.ReferralService.getCampaignDetails(this.user).then(function success(campaignDetails) {
                if (campaignDetails && campaignDetails.campaign_uid) {
                    this.showReferrAFriend = true;
                }
            }.bind(this));
        }
        ////////////////////////////////////////////////////////
        // END
        ////////////////////////////////////////////////////////


        this.visitedSignatureRoute = false;

        this.shouldShowAlmostComplete = SetupGuideService.setupGuideStats.completion === 99;

        if (this.user.isVendor() && this.company && this.company.subscribed && !this.DeviceService.isInAppBrowser() &&
            !this.NavigationService.isRouteActive(this.AppStates.root_core_login)) {

            branch.then(function(branchSdk) {
                branchSdk.banner({
                    icon: 'https://res.cloudinary.com/honeybook/image/upload/v1582028334/app/smart_banner/hb_logo.png',
                    title: 'HoneyBook',
                    description: 'Pocket-sized business & client management for creatives on-the-go.',
                    rating: 4.5,                              // Displays a star rating out of 5. Supports half stars through increments of .5
                    reviewCount: 616,                      // Amount of reviews your app has received next to the star rating
                    openAppButtonText: 'Open',              // Text to show on button if the user has the app installed
                    downloadAppButtonText: 'Get',           // Text to show on button if the user does not have the app installed
                    sendLinkText: 'Send Link',              // Text to show on desktop button to allow users to text themselves the app
                    phonePreviewText: '555-555-5555',      // The default phone placeholder is a US format number, localize the placeholder number with a custom placeholder with this option
                    showiOS: true,                          // Should the banner be shown on iOS devices (both iPhones and iPads)?
                    showiPad: false,                         // Should the banner be shown on iPads (this overrides showiOS)?
                    showAndroid: true,                      // Should the banner be shown on Android devices?
                    showBlackberry: false,                   // Should the banner be shown on Blackberry devices?
                    showWindowsPhone: false,                 // Should the banner be shown on Windows Phone devices?
                    showKindle: false,                       // Should the banner be shown on Kindle devices?
                    showDesktop: false,                      // Should the banner be shown on desktop devices?
                    iframe: true,                           // Show banner in an iframe, recomended to isolate Branch banner CSS
                    disableHide: false,                     // Should the user have the ability to hide the banner? (show's X on left side)
                    forgetHide: 2,                      // Should we show the banner after the user closes it? Can be set to true, or an integer to show again after X days
                    respectDNT: false,                      // Should we skip showing the banner when a user's settings show 'Do Not Track'?
                    mobileSticky: true,                    // Determines whether the mobile banner will be set `position: fixed;` (sticky) or `position: absolute;`, defaults to false *this property only applies when the banner position is 'top'
                    desktopSticky: true,                    // Determines whether the desktop banner will be set `position: fixed;` (sticky) or `position: absolute;`, defaults to true *this property only applies when the banner position is 'top'
                    make_new_link: false,                   // Should the banner create a new link, even if a link already exists?
                    open_app: false,                        // Should the banner try to open the app passively (without the user actively clicking) on load?,
                    customCSS: '#branch-banner .icon img {border-radius: 10px;} ' +
                        '.branch-banner-android #branch-banner .button {border-bottom: 3px solid #18C7C9; background-color: #18C7C9;}' +
                        '#branch-banner svg {fill: rgba(255, 180, 0, 1)}' +
                        '.branch-banner-ios #branch-banner .button {background-color: transparent; color: #0A84FF; border: none;}'
                }, {
                    tags: ['smart_banner'],
                    feature: 'smart_banner',
                    stage: 'new active user'
                });
            }.bind(this));
        }

    }

    var NavSmallScreensController = Class(Controllers.BaseController, {
        constructor: NavSmallScreensControllerFunc,

        closeMobileMenu: function closeMobileMenu() {
            this.showMobileMenu = false;
        },

        goToRoute: function goToRoute(routeName, stateParams) {
            this.goToRouteName = routeName;
            this.closeMobileMenu();

            if (this.goToRouteName) {
                if (this.NavigationService.isRouteActive(this.goToRouteName)) {
                    return;
                }

                this.goToState(this.goToRouteName, stateParams);
            }
        },

        saveStateAndCloseMenu: function saveStateAndCloseMenu() {
            // saveCurrentState isn't a function anymore?
            // this.SetupGuideService.saveCurrentState();
            this.closeMobileMenu();
        },

        createNewMobile: function createNewMobile() {
            if (this.user.hasTrialExpiredDueToNoPayment()) {
                this.ModalService.openTrialExpiringModal(false);
            } else if (this.user.shouldStartTrial()) {
                this.OnboardingService.openInProductIntakeForm(this.Enums.IntakeFormSource.topNav);
            } else {
                this.goToRoute(this.AppStates.root_core_navigation_create_new, {backToState : { name: this.$state.current.name, params: this.$state.params }});
            }

        },

        toggleMobileView: function goToMobileView(viewName) {
            switch (viewName) {

                case 'menu_mobile':
                    this.showMobileMenu = !this.showMobileMenu;
                    break;

                case 'search_mobile':
                    this.showSearchMobile = !this.showSearchMobile;
                    break;
            }
        },

        showSearchBox: function showSearchBox() {
            this.closeMobileMenu();
            this.showSearchMobile = true;
        },

        shouldShowSeePricing: function showSeePricing() {
            var isHomePage = this.$state.current.name === this.AppStates.root_core_navigation_home;
            return this.shouldBeAbleToUpgrade && isHomePage;
        },

        _checkPreviousState: function _checkPreviousState(routeName) {
            if (this.$state.previous) {
                return this.$state.previous.route.name === routeName;
            }

            return false;
        },

        handleClickNavIcon: function handleClickNavIcon() {
            this.NavigationService.goHistoryBack();
        },

        isCollapseIcon: function isCollapseIcon() {
            return (this.$state.$current.data &&
                   (this.$state.$current.data.backToState ||
                    this.$state.$current.data.backToHistoryOrState));
        },

        toggleNotificationsSettings: function toggleNotificationsSettings() {
            this.$rootScope.$broadcast('toggleNotificationsSettings');
        },

        isHideMobileNav: function() {
            return this.$state.$current.data &&
                   this.$state.$current.data.hideMobileNav === true;
        },

        onPlusButtonClick: function onPlusButtonClick() {
            this.NavigationService.onPlusButtonClickCallback();
        },

        onScheduleClick: function onScheduleClick() {
            this.$rootScope.$broadcast('handle-schedule-meeting', {
                source: "headerNav",
                isCreateMeeting: true
            });
        }
    });

    return {
        templateUrl: 'angular/app/modules/core/features/top_nav/nav_small_screens/nav_small_screens_template.html',
        controller: NavSmallScreensController,
        controllerAs: 'navSmallVm',
        bindToController: true,
    };
};
